import { Injectable } from '@angular/core';
import { HandlerService } from 'sslibs-handler';

@Injectable({
	providedIn: 'root'
})
export class AnimationService {
	public debugMode?: boolean;

	public easings = {
		easeInOutQuint: (t) => {
			return t < 0.5
				? 16 * t * t * t * t * t
				: 1 + 16 * --t * t * t * t * t;
		}
	};

	constructor(private handler: HandlerService) {}

	scroll(
		destination,
		padHeader?: boolean,
		duration = 500,
		easing = 'easeInOutQuint',
		callback?
	) {
		if (!this.handler.isBrowser) {
			return;
		}

		if (padHeader) {
			const header: any = document.getElementById('app-header')
				.children[0];

			if (header) {
				destination -= header.offsetHeight;
			}
		}

		const start = window.pageYOffset;
		const startTime =
			'now' in window.performance
				? performance.now()
				: new Date().getTime();

		const documentHeight = Math.max(
			document.body.scrollHeight,
			document.body.offsetHeight,
			document.documentElement.clientHeight,
			document.documentElement.scrollHeight,
			document.documentElement.offsetHeight
		);

		const windowHeight =
			window.innerHeight ||
			document.documentElement.clientHeight ||
			document.getElementsByTagName('body')[0].clientHeight;

		const destinationOffset =
			typeof destination === 'number'
				? destination
				: destination.offsetTop;

		const destinationOffsetToScroll = Math.round(
			documentHeight - destinationOffset < windowHeight
				? documentHeight - windowHeight
				: destinationOffset
		);

		if ('requestAnimationFrame' in window === false) {
			window.scroll(0, destinationOffsetToScroll);
			if (callback) {
				callback();
			}

			return;
		}

		let scroll = () => {
			const now =
				'now' in window.performance
					? performance.now()
					: new Date().getTime();
			const time = Math.min(1, (now - startTime) / duration);
			const timeFunction = this.easings[easing](time);
			window.scroll(
				0,
				Math.ceil(
					timeFunction * (destinationOffsetToScroll - start) + start
				)
			);

			if (this.debugMode) {
				console.log('Destination Offset: ', destinationOffsetToScroll);
				console.log('Page Offset: ', window.pageYOffset);
			}

			if (Math.abs(destinationOffsetToScroll - window.pageYOffset) <= 1) {
				if (callback) {
					callback();
				}
				return;
			}

			requestAnimationFrame(scroll);
		};

		// Set emergency timeout - See Issue #76
		setTimeout(() => {
			scroll = () => {};

			if (callback) {
				callback();
			}
		}, duration + 1);

		scroll();
	}
}
